const HOST = `https://api.parser.arbitrkit.ru`;
const APP_URL = `https://parser.arbitrkit.ru`;

export {
  HOST, APP_URL
}
